import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "col-md-12 container-fluid bg-white rounded shadow mt-3 p-3 text-start py-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "text-start" }, "จัดการเกี่ยวกับเรา", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = {
  class: "accordion",
  id: "accordionPanelsStayOpenExample"
}
const _hoisted_6 = { class: "accordion-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingOne"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseOne",
    "aria-expanded": "true",
    "aria-controls": "panelsStayOpen-collapseOne"
  }, "ภาษาไทย")
], -1)
const _hoisted_8 = {
  class: "accordion-collapse collapse show",
  id: "panelsStayOpen-collapseOne",
  "aria-labelledby": "panelsStayOpen-headingOne"
}
const _hoisted_9 = { class: "accordion-body" }
const _hoisted_10 = { class: "row text-start" }
const _hoisted_11 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย", -1)
const _hoisted_13 = { class: "accordion-item" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingTwo"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseTwo",
    "aria-expanded": "false",
    "aria-controls": "panelsStayOpen-collapseTwo"
  }, "ภาษาอังกฤษ")
], -1)
const _hoisted_15 = {
  class: "accordion-collapse collapse",
  id: "panelsStayOpen-collapseTwo",
  "aria-labelledby": "panelsStayOpen-headingTwo"
}
const _hoisted_16 = { class: "accordion-body" }
const _hoisted_17 = { class: "row text-start" }
const _hoisted_18 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย (ภาษาอังกฤษ)", -1)
const _hoisted_20 = { class: "accordion-item" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h2", {
  class: "accordion-header",
  id: "panelsStayOpen-headingThree"
}, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "accordion-button collapsed",
    type: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#panelsStayOpen-collapseThree",
    "aria-expanded": "false",
    "aria-controls": "panelsStayOpen-collapseThree"
  }, "ภาษาจีน")
], -1)
const _hoisted_22 = {
  class: "accordion-collapse collapse",
  id: "panelsStayOpen-collapseThree",
  "aria-labelledby": "panelsStayOpen-headingThree"
}
const _hoisted_23 = { class: "accordion-body" }
const _hoisted_24 = { class: "row text-start" }
const _hoisted_25 = { class: "col-sm-12 col-md-12 mb-3 mt-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "คำอธิบาย (ภาษาจีน)", -1)
const _hoisted_27 = { class: "d-flex mb-5 justify-content-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.doc.text1TH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.text1TH]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.doc.text1EN) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.text1EN]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "form-control",
                    style: {"height":"5em"},
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.doc.text1CH) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.doc.text1CH]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("a", {
            class: "btn btn-secondary bg-secondary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)))
          }, "บันทึก")
        ])
      ])
    ])
  ]))
}